import React from "react";

// ASSETS
import GA from "src/analytics/googleAnalytics";
import api from "src/store/features/api";

const DUMMY_TOKEN_DATA_WITHDRAW = {
  name: "",
  icon: "",
  code: "",
  availbility: 0,
  price: 0,
  memo: false,
  depositable: false,
  address: "",
};

const DUMMY_TOKEN_DATA_DEPOSIT = {
  name: "",
  icon: "",
  code: "",
  availbility: 0,
  price: 0,
  memo: "",
  format: "",
  depositable: false,
  address: "",
  id: "",
};

const useDropdown = () => {
  const [withdrawOpen, setWithdrawOpen] = React.useState<boolean>(false);
  const [depositOpen, setDepositOpen] = React.useState<boolean>(false);
  const [inactiveOpen, setInactiveOpen] = React.useState<boolean>(false);
  const [depositToken, setDepositToken] = React.useState(DUMMY_TOKEN_DATA_DEPOSIT);
  const [token, setWithdrawToken] = React.useState(DUMMY_TOKEN_DATA_WITHDRAW);
  const [depositError, setDepositError] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);

  // Get attribute data from DropdownList
  const getAttributeData = (event: any) => {
    const code = event?.currentTarget.getAttribute("data-code");
    const icon = event?.currentTarget.getAttribute("data-icon");
    const name = event?.currentTarget.getAttribute("data-name");
    const value = event?.currentTarget.getAttribute("data-value");
    const price = event?.currentTarget.getAttribute("data-price");
    const available = event?.currentTarget.getAttribute("data-available");
    const memo = event?.currentTarget.getAttribute("data-memo");
    const depositable = event?.currentTarget.getAttribute("data-depositable");
    const inactive = event?.currentTarget.getAttribute("data-inactive");
    const id = event?.currentTarget.getAttribute("data-id");
    const memoBoolean = memo === "true" ? true : false;
    const depositableBoolean = depositable === "true" ? true : false;
    const inactiveBoolean = inactive === "true" ? true : false;

    return {
      code,
      icon,
      name,
      value,
      price,
      available,
      depositable,
      memoBoolean,
      depositableBoolean,
      inactiveBoolean,
      id,
    };
  };

  // Format data to fit DropdownButton config data type
  const formatWithdrawData = (data: any) => {
    return data
      .map((item: any, index: number) => {
        return {
          depositable: item.currencyConfig.depositable,
          networkName: item.currencyConfig.networkName,
          inactive: item.currencyConfig.inactive,
          formatName: item.currencyConfig.name,
          memo: item.currencyConfig.memo,
          id: item.currencyConfig.id,
          type: item.currencyConfig.type,
          rank: item.rank || data.length + index,
          name: item.currencyConfig.name,
          code: item.currencyConfig.code,
          value: item.value,
          price: item.price,
          change: item.change,
          logoUrl: item.currencyConfig?.logoUrl,
          available: item.available,
        };
      })
      .sort((a: any, b: any) => a.rank - b.rank);
  };

  const removeInactiveTokens = (item: any) => {
    return !item.inactive;
  };

  const removeNotDepositableTokens = (item: any) => {
    if (!item.permissions?.deposit) return;
    return item.permissions?.deposit === true;
  };

  // format deposit data, filter out inactive tokens and sort by rank
  const formatDepositData = (data: any) => {
    return data
      .map((item: any, index: number) => {
        return {
          depositable: item.depositable,
          networkName: item.networkName,
          inactive: item.inactive,
          id: item.id,
          formatName: item.formatName,
          memo: item.memo,
          type: item.type,
          rank: item.rank || data.length + index,
          name: item.name,
          code: item.code,
          value: item.value,
          price: item.price,
          change: item.change,
          logoUrl: item?.logoUrl,
          available: item.available,
          permissions: item.permissions,
        };
      })
      .filter(removeInactiveTokens)
      .filter(removeNotDepositableTokens)
      .sort((a: any, b: any) => a.rank - b.rank);
  };
  const [getDepositAddress] = api.useLazyGetUserDepositAddressQuery();
  // FETCH ADDRESS CORRESPONDING TO TOKEN
  const fetchDepositAddress = async (code: string) => {
    return getDepositAddress({ token: code })
      .unwrap()
      .then((res) => {
        if (typeof res === "string") {
          throw new Error(res);
        }
        return res;
      })
      .catch((e) => {
        setDepositError(e.message);
      });
  };

  // onClick fn for deposit data
  const handleDepositClick = async (event: any, code: string) => {
    setLoading(true);
    if (depositError) setDepositError("");

    const attributes = getAttributeData(event);

    // if token is NOT inactive ⬇
    setDepositOpen((prev) => !prev);
    const data = await fetchDepositAddress(code);

    if (!data) return;
    setDepositToken({
      name: attributes.name,
      code: attributes.code,
      icon: attributes.icon,
      depositable: data.depositable,
      address: data.address || "",
      format: data.formatName || "",
      memo: data.memo || "",
      id: data.id || "",
      availbility: attributes.available,
      price: attributes.price,
    });

    setLoading(false);
    GA.modal("Deposit", "open");
  };

  // const removeNonFireblocksTokens = (item: any) => {
  //   return item.depositable;
  // };

  // onClick fn for withdraw data
  const handleWithdrawClick = (event: any, code: string) => {
    const attributes = getAttributeData(event);

    setWithdrawToken((prev) => ({
      ...prev,
      name: attributes.name,
      code: attributes.code,
      icon: attributes.icon,
      availbility: attributes.available,
      price: attributes.price,
      memo: attributes.memoBoolean,
    }));
    setWithdrawOpen((prev) => !prev);
    GA.modal("Withdraw", "open");
  };

  // Just throw whatever you want to use in this object
  const dropdown = {
    formatWithdrawData,
    formatDepositData,
    handleWithdrawClick,
    handleDepositClick,
    setDepositOpen,
    setWithdrawOpen,
    setInactiveOpen,
    loading,
    depositToken,
    token,
    depositOpen,
    depositError,
    withdrawOpen,
    inactiveOpen,
  };

  return dropdown;
};

export default useDropdown;
